<template>
  <v-page>
    <toolbar flat>
      <template v-slot:left>
        <span class="v-toolbar__text">
          {{ $t("pages.discover.discoverText") }}
        </span>
      </template>
    </toolbar>

    <tabs :initial-tab-index="initialTabIndex" :tabs="tabs">
      <template v-slot:programs="{ active }">
        <transition name="load-in" mode="out-in">
          <template v-if="active">
            <programs :active="active" />
          </template>
        </transition>
      </template>

      <template v-slot:events="{ active }">
        <transition name="load-in" mode="out-in">
          <template v-if="active">
            <event-schedule :active="active" />
          </template>
        </transition>
      </template>

      <template v-if="accountHasPublishedPacks" v-slot:packs="{ active }">
        <transition name="load-in" mode="out-in">
          <template v-if="active">
            <packs :active="active" />
          </template>
        </transition>
      </template>
    </tabs>
  </v-page>
</template>

<script>
import { mapGetters } from "vuex"

import Toolbar from "@/components/Toolbar"
import Tabs from "@/components/Tabs"

export default {
  components: {
    Toolbar,
    Tabs,
    Programs: () => import("@/components/discover/Programs"),
    EventSchedule: () => import("@/components/discover/EventSchedule"),
    Packs: () => import("@/components/discover/Packs")
  },

  computed: {
    ...mapGetters(["app"]),

    accountHasPublishedPacks() {
      return !!this.app.has_published_packs
    },

    initialTabIndex() {
      return this.$route.path === this.discoverEventsPath ? 1 : 0
    },

    discoverEventsPath() {
      return "/discover/events"
    },

    tabs() {
      const tabs = [
        { text: "Programs", path: "/discover/programs" },
        { text: "Events", path: this.discoverEventsPath }
      ]

      if (this.accountHasPublishedPacks) {
        tabs.push({
          text: "Packs",
          path: "/discover/packs"
        })
      }

      return tabs
    }
  }
}
</script>
